export default "__VITE_ASSET__Df6mW1W$__"